import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';

export type RequestEmailOtpAuthRequest = {
    email: string,
    locale: string
    current_entry_point: string
}

type RequestEmailOtpAuthSuccessResponse = {
    status: number
};

type RequestEmailOtpAuthErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type RequestEmailOtpResponse = RequestEmailOtpAuthSuccessResponse | RequestEmailOtpAuthErrorResponse;

export function requestEmailOtpAuth(data: RequestEmailOtpAuthRequest): Promise<RequestEmailOtpResponse> {
    return HubJsonRpcRequest.makeRequest<RequestEmailOtpResponse, RequestEmailOtpAuthRequest>(
        HubApiMethods.REQUEST_EMAIL_OTP_AUTH,
        data,
        window.app.deviceIdentifier
    );
}
